"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarComponent = void 0;
const base_component_1 = require("../base-component");
const utils_1 = require("../../utils/utils");
const key_1 = require("../../utils/key");
const dom_1 = require("../../utils/dom");
const BODY_ELEMENT_SELECTOR = 'body-element';
class SidebarComponent extends base_component_1.BaseComponent {
    template;
    element;
    touchStartX;
    touchStartY;
    touchEndX;
    touchEndY;
    isOpen;
    constructor() {
        super();
        if (this.hasAttribute('is-open-on-init')) {
            this.element = (0, utils_1.$el)('[data-sidebar-body]', this);
        }
        else {
            this.element = (0, dom_1.getTemplateFirstChild)((0, utils_1.$el)(`[data-sidebar-template="${this.id}"]`, this));
        }
        this.isOpen = this.classList.contains('is-opened');
    }
    mountComponent() {
        super.mountComponent();
        if (this.isEditor) {
            if (!this.isSection && this.id != "ShopCollectionFilter") {
                this.hide(true);
            }
            this.editor.on('SECTION_SELECT', this.handleSectionSelect);
            this.editor.on('SECTION_DESELECT', this.handleSectionDeselect);
        }
    }
    handleSidebarFocusout = event => {
        const bodyElement = (0, utils_1.$el)(BODY_ELEMENT_SELECTOR);
        const focusTarget = event.relatedTarget;
        const isLastOpenedWindow = bodyElement.isLastOpenedWindow(this.id);
        const isfocusTargetOut = !focusTarget || !this.contains(focusTarget);
        if (isfocusTargetOut && isLastOpenedWindow && bodyElement.isUsingKeyboard) {
            const { firstTarget } = (0, utils_1.getTargets)(this.element);
            firstTarget.focus();
        }
    };
    handleSectionSelect = ({ detail: { sectionId } }) => {
        if (this.isSection && this.dataset.sectionId === sectionId) {
            this.open();
        }
    };
    handleSectionDeselect = ({ detail: { sectionId } }) => {
        if (this.isSection && this.dataset.sectionId === sectionId) {
            this.hide();
        }
    };
    handleOutsideClick = (event) => {
        const isOverlay = (0, utils_1.$elParent)(BODY_ELEMENT_SELECTOR, event.target);
        if (isOverlay && this.isOpen) {
            this.hide();
        }
    };
    handleTouchStart = (event) => {
        this.touchStartX = event.targetTouches[0].clientX;
        this.touchStartY = event.targetTouches[0].clientY;
    };
    handleTouchMove = (event) => {
        this.touchEndX = event.targetTouches[0].clientX;
        this.touchEndY = event.targetTouches[0].clientY;
    };
    handleTouchEnd = (event) => {
        const X_DIRECTION_THRESHOLD = this.offsetWidth / 2;
        const Y_DIRECTION_THRESHOLD = 48;
        const distanceX = Math.abs(this.touchStartX - this.touchEndX);
        const distanceY = Math.abs(this.touchStartY - this.touchEndY);
        const isCarousel = (0, utils_1.$elParent)('[data-carousel-viewport]', event.target);
        const isPriceRange = (0, utils_1.$elParent)('price-range', event.target);
        if (isCarousel || isPriceRange) {
            this.cleanTouchPoints();
            return;
        }
        if (this.touchEndX === 0) {
            this.cleanTouchPoints();
            return;
        }
        if (distanceY > Y_DIRECTION_THRESHOLD) {
            this.cleanTouchPoints();
            return;
        }
        const isTrigger = this.dataset.openDirection === 'right'
            ? this.touchStartX < this.touchEndX
            : this.touchStartX > this.touchEndX;
        if (this.isOpen && distanceX > X_DIRECTION_THRESHOLD && isTrigger) {
            this.hide();
        }
        this.cleanTouchPoints();
    };
    handleKeydown = (event) => {
        const withCloseOnEscape = this.hasAttribute('data-with-close-on-escape');
        if (withCloseOnEscape && (0, key_1.isEscKey)(event)) {
            event.preventDefault();
            this.hide();
        }
    };
    cleanTouchPoints() {
        this.touchStartX = 0;
        this.touchEndX = 0;
        this.touchStartY = 0;
        this.touchEndY = 0;
    }
    async open(event) {
        const bodyElement = (0, utils_1.$el)(BODY_ELEMENT_SELECTOR);
        (0, utils_1.whenDefined)('body-element').then(() => {
            bodyElement.addDialogWindow(this.id);
        });
        this.mount();
        this.setOpenState(true);
        await (0, utils_1.transitionToPromise)(this);
        const videos = (0, utils_1.$list)('lazy-video, video', this);
        videos.forEach(video => {
            video.play ? video.play() : video.initVideo();
        });
        this.initFocus();
        this.toggleListeners(true);
        this.toggleCloseCursor(event);
    }
    async hide(isInstant) {
        const bodyElement = (0, utils_1.$el)(BODY_ELEMENT_SELECTOR);
        (0, utils_1.whenDefined)('body-element').then(() => {
            bodyElement.removeDialogWindow(this.id);
        });
        this.toggleListeners(false);
        this.toggleCloseCursor();
        this.setOpenState(false);
        if (isInstant) {
            this.unmount();
        }
        else {
            await (0, utils_1.transitionToPromise)(this);
            this.unmount();
        }
    }
    initFocus() {
        if ((0, utils_1.isNotIframe)()) {
            const { firstTarget } = (0, utils_1.getTargets)(this);
            firstTarget?.focus();
        }
    }
    async toggle(event) {
        if (this.isOpen) {
            this.hide();
        }
        else {
            this.open(event);
        }
    }
    mount() {
        this.replaceChildren(this.element);
    }
    unmount() {
        this.replaceChildren();
    }
    updateTemplate(template) {
        this.element = (0, dom_1.getTemplateFirstChild)(template);
        this.replaceChildren(this.element);
    }
    setOpenState(isOpen) {
        this.isOpen = isOpen;
        const withOverlay = this.hasAttribute('data-with-overlay');
        const buttons = (0, utils_1.$list)(`[data-sidebar-button][data-sidebar-id="${this.id}"]`);
        this.setVisible(isOpen);
        if (withOverlay) {
            const isImportant = this.hasAttribute('data-overlay-important');
            const hasCustomOpacity = this.hasAttribute('data-overlay-opacity');
            const computedStyles = getComputedStyle(this);
            const bodyElement = (0, utils_1.$el)(BODY_ELEMENT_SELECTOR);
            let styles = {};
            if (isImportant) {
                styles = { ...styles, zIndex: parseFloat(computedStyles['zIndex']) - 1 };
            }
            if (hasCustomOpacity) {
                styles = {
                    ...styles,
                    '--gsc-overlay-opacity': +this.getAttribute('data-overlay-opacity'),
                };
            }
            (0, utils_1.whenDefined)('body-element').then(() => {
                if (isOpen) {
                    bodyElement.showOverlay(this.id, styles);
                }
                else {
                    bodyElement.hideOverlay(this.id);
                }
            });
        }
        buttons.forEach(button => {
            button.classList.toggle('is-opened', isOpen);
        });
    }
    setVisible(isVisible) {
        this.classList.toggle('is-opened', isVisible);
    }
    toggleCloseCursor = (event) => {
        const closeCursor = (0, utils_1.$el)('close-cursor');
        (0, utils_1.whenDefined)('close-cursor').then(() => {
            closeCursor?.toggle(event);
        });
    };
    toggleListeners = boolean => {
        const withOutsideClick = this.hasAttribute('data-with-close-on-outside');
        if (boolean) {
            this.addListener(window, 'keydown', this.handleKeydown);
            this.addListener(this, 'focusout', this.handleSidebarFocusout);
            this.addListener(this, 'touchstart', this.handleTouchStart);
            this.addListener(this, 'touchmove', this.handleTouchMove);
            this.addListener(this, 'touchend', this.handleTouchEnd);
            if (withOutsideClick) {
                this.addListener(window, 'click', this.handleOutsideClick);
            }
        }
        else {
            this.removeListener(window, 'keydown', this.handleKeydown);
            this.removeListener(this, 'focusout', this.handleSidebarFocusout);
            this.removeListener(this, 'touchstart', this.handleTouchStart);
            this.removeListener(this, 'touchmove', this.handleTouchMove);
            this.removeListener(this, 'touchend', this.handleTouchEnd);
            if (withOutsideClick) {
                this.removeListener(window, 'click', this.handleOutsideClick);
            }
        }
    };
    get isSection() {
        return this.hasAttribute('data-sidebar-section');
    }
}
exports.SidebarComponent = SidebarComponent;
